import React, { useEffect, useState } from 'react';
import Logo from './Logo';
import LanguageToggle from './LanguageToggle';
import { useI18n } from '../i18n/LanguageContext';

const NAV = [
  { id: 'home', labelKey: 'nav.home' },
  { id: 'about', labelKey: 'nav.about' },
  { id: 'pilgrimages', labelKey: 'nav.pilgrimages' },
  { id: 'testimonials', labelKey: 'nav.testimonials' },
  { id: 'contact', labelKey: 'nav.contact' },
];

const ADMIN_URL = process.env.REACT_APP_ADMIN_URL || 'https://admin.indabozamariya.rw';

export default function Header() {
  const { t } = useI18n();
  const [active, setActive] = useState('home');

  // Highlight whichever section is closest to the top of the viewport. An
  // IntersectionObserver fires as sections scroll in/out; we keep the most
  // recently intersected one as the active anchor.
  useEffect(() => {
    const ids = NAV.map((n) => n.id);
    const targets = ids
      .map((id) => document.getElementById(id))
      .filter(Boolean);
    if (targets.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        // Choose the entry that's most visible at the moment of the callback.
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) setActive(visible.target.id);
      },
      {
        // Section is "active" once its top crosses ~30% down the viewport.
        rootMargin: '-30% 0px -55% 0px',
        threshold: [0, 0.25, 0.5, 0.75, 1],
      }
    );

    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const handleClick = (e, id) => {
    const el = document.getElementById(id);
    if (!el) return;          // anchor with no target — let the browser handle it
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setActive(id);
    // Keep the URL in sync so refresh + back/forward still land in the right spot.
    if (window.history.replaceState) {
      window.history.replaceState(null, '', id === 'home' ? '#' : `#${id}`);
    }
  };

  return (
    <header className="site-header">
      <div className="site-header-inner">
        <Logo />
        <nav className="site-nav" aria-label="Primary">
          {NAV.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(e) => handleClick(e, item.id)}
              className={'site-nav-link' + (active === item.id ? ' is-active' : '')}
            >
              {t(item.labelKey)}
            </a>
          ))}
        </nav>
        <div className="site-header-actions">
          <LanguageToggle />
          <a className="site-login-btn" href={ADMIN_URL}>{t('nav.login')}</a>
        </div>
      </div>
    </header>
  );
}
